module.exports = "/contribution/resources/3cbaa07ed8244df2d8add3c035a744e5.png";